/**
 * Uncanny Coupon Login
 *
 * @author Uncanny Owl
 * @version 1.0.0
 */
jQuery(document).ready(function ($) {
	$("#coupon-length").keypress(function (e) {
		if (e.which === 10 || e.which === 13) {
			e.preventDefault();
		}
	});

	$('.uo-btn-delete').on('click', function (e) {
		if (!confirm(uoCodesStrings.Doyoureallywanttodeletethesecodes)) e.preventDefault();
	});

	// Removed .uo-btn-delete-code handler to prevent double confirmation
	// Let the delete links work naturally with server-side confirmation only

	$('.uo-btn-replace').on('click', function (e) {
		if (!confirm(uoCodesStrings.Doyoureallywanttoreplacethiscode)) e.preventDefault();
	});

	$('.uo-btn-cancel').on('click', function (e) {
		if (!confirm(uoCodesStrings.Doyoureallywanttocancelthiscode)) e.preventDefault();
	});

	jQuery(document).ready(function ($) {
	// Unified Bulk Update System - handles 1 or more codes
	
	// Create single reusable modal
	function createBulkExpiryModal() {
		if ($('#bulk-expiry-modal').length) return; // Already exists
		
		const modalHtml = `
			<div id="bulk-expiry-modal" class="uncannyowl-modal-overlay">
 				<div class="uncannyowl-modal-content  uncannyowl-modal-centered uncannyowl-modal-width-sm">
				 
						<div class="uncannyowl-modal-header">
							<h3 class="uncannyowl-modal-title">${UncannyCodes.i18n?.setExpiryDate || 'Set Expiry Date'}</h3>
							<button class=" uncannyowl-modal-close">&times;</button>
						</div>
						<div class="uncannyowl-modal-body">
							
							<div class="uncannyowl-alert uncannyowl-alert-info">
								<strong id="selected-count-text">0 codes selected</strong> 
							</div>
							
							<div class="uncannyowl-form-field p-0 bulk-form-group">
								<label for="bulk-expiry-date">${UncannyCodes.i18n?.expiryDate || 'Expiry Date'}:</label>
								<input type="date" id="bulk-expiry-date"  class="uncannyowl-input" required>
							</div> 

							<div class="uncannyowl-form-field  p-0">
								<label for="bulk-expiry-time">${UncannyCodes.i18n?.expiryTime || 'Expiry Time'} (optional):</label>
								<input type="time" id="bulk-expiry-time"  class="uncannyowl-input" value="23:59">
							</div>

						
						</div>
 
					<div class="uncannyowl-modal-footer"> 
						<div class="uncannyowl-modal-actions">
							<div class="action-left">
								 
							</div>
							<div class="action-right">
								<button type="button" class="uncannyowl-btn uncannyowl-btn--secondary"  id="bulk-cancel-expiry">${UncannyCodes.i18n?.cancel || 'Cancel'} </button>
								<button type="button" class="uncannyowl-btn  uncannyowl-btn--primary " id="bulk-save-expiry">${UncannyCodes.i18n?.save || 'Save'}</button>
							</div>
						</div>
					</div>  
 
					 
				</div>
			</div>
		`;
		
		$('body').append(modalHtml);
		 
	}
	
	// Handle "Select All" checkbox functionality
	$(document).on('change', '#cb-select-all-1, #cb-select-all-2', function() {
		const isChecked = $(this).prop('checked');
		$('.code-checkbox').prop('checked', isChecked);
	});

	// Update "Select All" when individual checkboxes change
	$(document).on('change', '.code-checkbox', function() {
		const totalCheckboxes = $('.code-checkbox').length;
		const checkedCheckboxes = $('.code-checkbox:checked').length;
		
		$('#cb-select-all-1, #cb-select-all-2').prop('checked', totalCheckboxes === checkedCheckboxes);
	});

	// Handle bulk actions
	$(document).on('click', '#doaction, #doaction2', function(e) {
		// Find the bulk action select - it might be a sibling or in the same container
		const action = $(this).siblings('select').val() || $('#bulk-action-selector-top').val() || $('#bulk-action-selector-bottom').val();
		
		if (action === 'bulk_update_expiry') {
			e.preventDefault();
			
			// Get selected codes
			const selectedCodes = $('.code-checkbox:checked').map(function() {
				return $(this).val();
			}).get();
			
			if (selectedCodes.length === 0) {
				alert(UncannyCodes.i18n?.pleaseSelectCodes || 'Please select at least one code to update.');
				return;
			}
			
			createBulkExpiryModal();
			
			// Update modal with selection info
			const countText = selectedCodes.length === 1 
				? '1 code selected' 
				: selectedCodes.length + ' codes selected';
			$('#selected-count-text').text(countText);
			
			// Show modal
			$('#bulk-expiry-modal').fadeIn(200);
		$('.uncannyowl-modal-overlay').addClass('active');
			$('#bulk-expiry-date').focus();
			
			// Store selected codes for later use
			$('#bulk-expiry-modal').data('selected-codes', selectedCodes);
		} else if (action === 'bulk_download') {
			e.preventDefault();
			
			// Get selected codes
			const selectedCodes = $('.code-checkbox:checked').map(function() {
				return $(this).val();
			}).get();
			
			if (selectedCodes.length === 0) {
				alert(UncannyCodes.i18n?.pleaseSelectCodes || 'Please select at least one code to download.');
				return;
			}
			
			// Create a form to submit the download request
			const form = $('<form>', {
				method: 'POST',
				action: window.location.href
			});
			
			// Add selected code IDs as hidden inputs
			selectedCodes.forEach(function(codeId) {
				form.append($('<input>', {
					type: 'hidden',
					name: 'code_ids[]',
					value: codeId
				}));
			});
			
			// Add action and nonce
			form.append($('<input>', {
				type: 'hidden',
				name: 'action',
				value: 'bulk_download'
			}));
			
			form.append($('<input>', {
				type: 'hidden',
				name: '_wpnonce',
				value: UncannyCodes.nonce
			}));
			
			form.append($('<input>', { type: 'hidden', name: 'page', value: 'uncanny-learndash-codes' }));
			
			// Add to body and submit
			form.appendTo('body').submit();
		} else if (action === 'bulk_replace') {
			e.preventDefault();
			
			// Get selected codes
			const selectedCodes = $('.code-checkbox:checked').map(function() {
				return $(this).val();
			}).get();
			
			if (selectedCodes.length === 0) {
				alert(UncannyCodes.i18n?.pleaseSelectCodes || 'Please select at least one code to replace.');
				return;
			}
			
			const confirmMessage = selectedCodes.length === 1 
				? (uoCodesStrings.Doyoureallywanttoreplacethiscode || 'Are you sure you want to replace this code?')
				: 'Are you sure you want to replace these ' + selectedCodes.length + ' codes?';
			
			if (!confirm(confirmMessage)) {
				return;
			}
			
			// Create form for replace action
			const form = $('<form>', {
				method: 'POST',
				action: window.location.href
			});
			
			selectedCodes.forEach(function(codeId) {
				form.append($('<input>', {
					type: 'hidden',
					name: 'code_ids[]',
					value: codeId
				}));
			});
			
			form.append($('<input>', { type: 'hidden', name: 'action', value: 'bulk_replace' }));
			form.append($('<input>', { type: 'hidden', name: '_wpnonce', value: UncannyCodes.nonce }));
			form.append($('<input>', { type: 'hidden', name: 'page', value: 'uncanny-learndash-codes' }));
			form.appendTo('body').submit();
			
		} else if (action === 'bulk_cancel') {
			e.preventDefault();
			
			// Get selected codes
			const selectedCodes = $('.code-checkbox:checked').map(function() {
				return $(this).val();
			}).get();
			
			if (selectedCodes.length === 0) {
				alert(UncannyCodes.i18n?.pleaseSelectCodes || 'Please select at least one code to cancel.');
				return;
			}
			
			const confirmMessage = selectedCodes.length === 1 
				? (uoCodesStrings.Doyoureallywanttocancelthiscode || 'Are you sure you want to cancel this code?')
				: 'Are you sure you want to cancel these ' + selectedCodes.length + ' codes?';
			
			if (!confirm(confirmMessage)) {
				return;
			}
			
			// Create form for cancel action  
			const form = $('<form>', {
				method: 'POST',
				action: window.location.href
			});
			
			selectedCodes.forEach(function(codeId) {
				form.append($('<input>', {
					type: 'hidden',
					name: 'code_ids[]',
					value: codeId
				}));
			});
			
			form.append($('<input>', { type: 'hidden', name: 'action', value: 'bulk_cancel' }));
			form.append($('<input>', { type: 'hidden', name: '_wpnonce', value: UncannyCodes.nonce }));
			form.append($('<input>', { type: 'hidden', name: 'page', value: 'uncanny-learndash-codes' }));
			
			form.appendTo('body').submit();
			
		} else if (action === 'bulk_delete') {
			e.preventDefault();
			
			// Get selected codes
			const selectedCodes = $('.code-checkbox:checked').map(function() {
				return $(this).val();
			}).get();
			
			if (selectedCodes.length === 0) {
				alert(UncannyCodes.i18n?.pleaseSelectCodes || 'Please select at least one code to delete.');
				return;
			}
			
			const confirmMessage = selectedCodes.length === 1 
				? (uoCodesStrings.Doyoureallywanttodeletethiscode || 'Are you sure you want to delete this code?')
				: 'Are you sure you want to delete these ' + selectedCodes.length + ' codes? This action cannot be undone.';
			
			if (!confirm(confirmMessage)) {
				return;
			}
			
			// Create form for delete action
			const form = $('<form>', {
				method: 'POST',
				action: window.location.href
			});
			
			selectedCodes.forEach(function(codeId) {
				form.append($('<input>', {
					type: 'hidden',
					name: 'code_ids[]',
					value: codeId
				}));
			});
			
			form.append($('<input>', { type: 'hidden', name: 'action', value: 'bulk_delete' }));
			form.append($('<input>', { type: 'hidden', name: '_wpnonce', value: UncannyCodes.nonce }));
			form.append($('<input>', { type: 'hidden', name: 'page', value: 'uncanny-learndash-codes' }));
			form.appendTo('body').submit();
		}
	});
	
	// Modal close handlers
	$(document).on('click', '.uncannyowl-modal-close, #bulk-cancel-expiry', function() {
		$('#bulk-expiry-modal').fadeOut(200);
		$('.uncannyowl-modal-overlay').removeClass('active');
	});
	
	// Close on overlay click
	$(document).on('click', '.uncannyowl-modal-overlay', function(e) {
		if (e.target === this) {
			$('#bulk-expiry-modal').fadeOut(200);
			$('.uncannyowl-modal-overlay').removeClass('active');
		}
	});
     
	
	// Escape key to close
	$(document).on('keydown', function(e) {
		if (e.key === 'Escape' && $('#bulk-expiry-modal').is(':visible')) {
			$('#bulk-expiry-modal').fadeOut(200);
			$('.uncannyowl-modal-overlay').removeClass('active');
		}
	});
	
	// Save bulk expiry
	$(document).on('click', '#bulk-save-expiry', function() {
		const expiryDate = $('#bulk-expiry-date').val();
		const expiryTime = $('#bulk-expiry-time').val() || '23:59:59';
		const selectedCodes = $('#bulk-expiry-modal').data('selected-codes');
		
		if (!expiryDate) {
			alert(UncannyCodes.i18n?.pleaseEnterDate || 'Please enter an expiry date.');
			$('#bulk-expiry-date').focus();
			return;
		}
		
		// Disable save button and show loading
		const $saveBtn = $(this);
		const originalText = $saveBtn.text();
		$saveBtn.prop('disabled', true).text('').addClass('uncannyowl-btn uncannyowl-btn--primary uncannyowl-btn--loading');;
		
		$.ajax({
			url: "/wp-json/uncanny-codes/v1/bulk_update_expiry_date",
			method: "POST",
			beforeSend: function (xhr) {
				xhr.setRequestHeader("X-WP-Nonce", UncannyCodes.nonce);
			},
			data: {
				code_ids: selectedCodes,
				expire_date: expiryDate,
				expiry_time: expiryTime
			},
			success: function (response) {
				if (response.success) {
					showNotification(response.message, 'success');
					
					// Update table cells or reload page
					setTimeout(function() {
						location.reload(); // For now, reload page - could be optimized to update cells directly
					}, 1500);
					
					// Close modal
					$('#bulk-expiry-modal').fadeOut(200);
				} else {
					showNotification(response.message || (UncannyCodes.i18n?.failedToUpdate || 'Failed to update expiry dates.'), 'error');
				}
			},
			error: function (xhr, status, error) {
				console.error('Bulk update error:', xhr.responseText);
				let errorMsg = UncannyCodes.i18n?.errorOccurred || 'An error occurred';
				
				// Try to parse error response
				try {
					const errorResponse = JSON.parse(xhr.responseText);
					errorMsg = errorResponse.message || errorMsg;
				} catch (e) {
					errorMsg += ': ' + error;
				}
				
				showNotification(errorMsg, 'error');
			},
			complete: function() {
				$saveBtn.prop('disabled', false).text(originalText).removeClass('uncannyowl-btn--loading');
			}
		});
	});
	
	// Helper function to show notifications
	function showNotification(message, type = 'info') {
		// Create notification element
		const notification = $(`
			<div class="bulk-notification bulk-notification--${type}">
				<div class="bulk-notification-content">
					${message}
				</div>
			</div>
		`);
		
		// Add notification CSS if not exists
		if (!$('#bulk-notification-css').length) {
			$('head').append(`
				<style id="bulk-notification-css">
				.bulk-notification {
					position: fixed; top: 32px; right: 20px; z-index: 100002;
					min-width: 300px; max-width: 500px; border-radius: 6px;
					box-shadow: 0 4px 20px rgba(0,0,0,0.15); 
					animation: slideInRight 0.3s ease-out;
				}
				.bulk-notification-content {
					padding: 16px 20px; color: white; font-weight: 500; line-height: 1.4;
				}
				.bulk-notification--success { background: #46b450; }
				.bulk-notification--error { background: #dc3232; }
				.bulk-notification--info { background: #0073aa; }
				@keyframes slideInRight {
					from { transform: translateX(100%); opacity: 0; }
					to { transform: translateX(0); opacity: 1; }
				}
				</style>
			`);
		}
		
		// Show notification
		$('body').append(notification);
		
		// Auto-hide after 4 seconds
		setTimeout(() => {
			notification.fadeOut(400, function() {
				$(this).remove();
			});
		}, 4000);
	}
	
	// Legacy single code edit support (for backward compatibility)
	$(document).on('click', '.uo-btn-edit-code', function (e) {
		// Check if this is a navigation link (has href and not "#") vs modal trigger
		const href = $(this).attr('href');
		if (href && href !== '#') {
			// This is a navigation link - let it work normally
			return true;
		}
		
		// This is a modal trigger - prevent default and open modal
		e.preventDefault();
		
		const codeId = $(this).data("code-id");
		const $checkbox = $(`.code-checkbox[value="${codeId}"]`);
		
		// Select this code's checkbox
		$('.code-checkbox').prop('checked', false);
		$checkbox.prop('checked', true);
		
		// Trigger bulk update with single item
		$('#bulk-action-selector-top').val('bulk_update_expiry');
		$('#doaction').trigger('click');
	});
	
	// Click to copy functionality for code values
	$(document).on('click', '.code-value', function(e) {
		e.preventDefault();
		
		const codeText = $(this).text().trim();
		const $element = $(this);
		
		// Use modern Clipboard API if available
		if (navigator.clipboard && window.isSecureContext) {
			navigator.clipboard.writeText(codeText).then(function() {
				showCopyFeedback($element, 'Copied!');
			}).catch(function() {
				// Fallback to older method
				fallbackCopyToClipboard(codeText, $element);
			});
		} else {
			// Fallback for older browsers
			fallbackCopyToClipboard(codeText, $element);
		}
	});
	
	// Fallback copy method for older browsers
	function fallbackCopyToClipboard(text, $element) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.left = '-9999px';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		
		try {
			const successful = document.execCommand('copy');
			if (successful) {
				showCopyFeedback($element, 'Copied!');
			} else {
				showCopyFeedback($element, 'Copy failed', 'error');
			}
		} catch (err) {
			showCopyFeedback($element, 'Copy failed', 'error');
		}
		
		document.body.removeChild(textArea);
	}
	
	// Show copy feedback
	function showCopyFeedback($element, message, type = 'success') {
		// Create tooltip element
		const tooltip = $(`
			<div class="copy-feedback-tooltip copy-feedback-tooltip--${type}">
				${message}
			</div>
		`);
		
		// Add tooltip CSS if not exists
		if (!$('#copy-feedback-css').length) {
			$('head').append(`
				<style id="copy-feedback-css">
				.copy-feedback-tooltip {
					position: absolute;
					background: #46b450;
					color: white;
					padding: 4px 8px;
					border-radius: 4px;
					font-size: 12px;
					font-weight: 500;
					z-index: 10000;
					pointer-events: none;
					white-space: nowrap;
					box-shadow: 0 2px 8px rgba(0,0,0,0.2);
					animation: fadeInUp 0.2s ease-out;
				}
				.copy-feedback-tooltip--error {
					background: #dc3232;
				}
				.copy-feedback-tooltip::after {
					content: '';
					position: absolute;
					top: 100%;
					left: 50%;
					margin-left: -4px;
					border-width: 4px;
					border-style: solid;
					border-color: #46b450 transparent transparent transparent;
				}
				.copy-feedback-tooltip--error::after {
					border-color: #dc3232 transparent transparent transparent;
				}
				@keyframes fadeInUp {
					from { opacity: 0; transform: translateY(4px); }
					to { opacity: 1; transform: translateY(0); }
				}
				</style>
			`);
		}
		
		// Position tooltip above the element
		const offset = $element.offset();
		const elementWidth = $element.outerWidth();
		
		tooltip.css({
			position: 'absolute',
			top: offset.top - 35,
			left: offset.left + (elementWidth / 2),
			transform: 'translateX(-50%)'
		});
		
		// Add tooltip to body
		$('body').append(tooltip);
		
		// Remove tooltip after 1.5 seconds
		setTimeout(function() {
			tooltip.fadeOut(200, function() {
				$(this).remove();
			});
		}, 1500);
		
		// Brief highlight effect on the code element
		$element.css({
			'background-color': '#f0f8ff',
			'transition': 'background-color 0.2s ease'
		});
		
		setTimeout(function() {
			$element.css('background-color', '');
		}, 300);
	}
});
	
	

	render_code();

	$("input[name='coupon-length'], input[name='coupon-prefix'], input[name='coupon-suffix'], input[name='coupon-dash']").on('input', function (e) {
		render_code();
	});

	$("input[type=checkbox][name='coupon-character-type[]']").change(function (e) {
		render_code();
	});

	function render_code(returnCode = false) {
		if ($('#uoc-generate-code-preview-fake-code').length > 0) {
			var chars = uoCodesStrings.avail_characters,
				dashes = $("input[name='coupon-dash']").val(),
				coupon_length = $("input[name='coupon-length']").val(),
				prefix = $("input[name='coupon-prefix']").val(),
				prefix_length = prefix.length,
				suffix = $("input[name='coupon-suffix']").val(),
				suffix_length = suffix.length,
				random_string = '';

			var code_char_type = $("input[type=checkbox][name='coupon-character-type[]']:checked").map(function () {
				return $(this).val();
			}).get();

			if ($.inArray('lowercase-letters', code_char_type) == -1) {
				chars = chars.replace('abcdefghjkmnpqrstuvwxyz', '');
			}

			if ($.inArray('uppercase-letters', code_char_type) == -1) {
				chars = chars.replace('ABCDEFGHJKLMNPQRSTUVWXYZ', '');
			}

			if ($.inArray('numbers', code_char_type) == -1) {
				chars = chars.replace('123456789', '');
			}
			if (chars.length == 0) {
				chars = '123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
			}
			coupon_length = coupon_length - prefix_length - suffix_length;

			for (var i = 0; i < coupon_length; i++) {
				var rnum = Math.floor(Math.random() * chars.length);
				random_string += chars.substring(rnum, rnum + 1);
			}

			var strings = prefix + random_string + suffix;

			if (dashes) {
				dashes = dashes.split('-');
				var strings_arr = strings.split(''),
					new_string = '',
					dash_inside_pointer = 0,
					dash_index = 0;

				$(strings_arr).each(function (i) {
					new_string = new_string + $(this)[0];
					dash_inside_pointer++;

					if (dashes[dash_index] <= dash_inside_pointer) {
						dash_index++;
						dash_inside_pointer = 0;
						new_string = new_string + "-";
					}
				});

				if (new_string.substring(new_string.length - 1, new_string.length) == "-") {
					new_string = new_string.substring(0, new_string.length - 1);
				}
			} else {
				var new_string = strings;
			}
			if (returnCode) {
				return new_string;
			} else {
				$("#uoc-generate-code-preview-fake-code").html(new_string);
			}
		}
	}

	function change_assign_form() {
		if ($("#uncanny_form_input_vendor #assign_where").val() == "courses") {
			$("#uncanny_form_input_vendor #assign_courses").show();
			$("#uncanny_form_input_vendor #assign_lessons").hide();

		} else {
			$("#uncanny_form_input_vendor #assign_courses").hide();
			$("#uncanny_form_input_vendor #assign_lessons").show();
		}
	}

	if ($("#uncanny_form_input_vendor #assign_where").length) {
		change_assign_form();

		$("#uncanny_form_input_vendor #assign_where").change(function () {
			change_assign_form();
		});
	}

	$("#page_coupon_stat .btn_delete, #page_coupon_stat .btn_delete").click(function (e) {
		if (!confirm(uoCodesStrings.Doyoureallywanttodeletethis)) e.preventDefault();
	});

	// Prefix Selector for View Coupon by Group
	$('#prefix_selector_for_coupon_group').change(function () {
		if ($(this).val()) {
			location.href = add_query_arg('prefix', $(this).val());
		} else {
			location.href = remove_query_arg('prefix');
		}
	});

	$('#badge_selector_for_coupon_group').change(function () {
		if ($(this).val()) {
			location.href = add_query_arg('badge_id', $(this).val());
		} else {
			location.href = remove_query_arg('badge_id');
		}
	});
});

function add_query_arg(key, value, url) {
	if (!url) url = location.href;

	key = escape(key);
	value = escape(value);

	if (!value) return remove_query_arg(key, url);

	var pair = key + "=" + value;
	var exp = new RegExp("(&|\\?)" + key + "=[^\&]*");
	url = url.replace(exp, "$1" + pair);

	if (url.indexOf(key + '=') > -1) {
	} else {
		if (url.indexOf('?') > -1) {
			url += '&' + pair;
		} else {
			url += '?' + pair;
		}
	}

	return url;
}

function remove_query_arg(key, url) {
	if (!url) url = location.href;

	key = escape(key);

	var exp = new RegExp("(&|\\?)" + key + "=[^\&]*");
	url = url.replace(exp, '');

	return url;
}

jQuery.fn.regexMask = function (mask) {
	jQuery(this).keypress(function (event) {
		if (!event.charCode) return true;
		var part1 = this.value.substring(0, this.selectionStart);
		var part2 = this.value.substring(this.selectionEnd, this.value.length);
		if (!mask.test(part1 + String.fromCharCode(event.charCode) + part2))
			return false;
	});
};

jQuery(document).ready(function () {
	var mask = new RegExp('^[A-Za-z0-9]*$')
	jQuery("input.regex-alphanumeric").regexMask(mask)
	
	// Handle file input display
	jQuery(document).on('change', '.uncannyowl-file-input', function() {
		const $input = jQuery(this);
		const $wrapper = $input.closest('.uncannyowl-file-input-wrapper');
		const $filename = $wrapper.find('.uncannyowl-file-input-filename');
		
		if (this.files && this.files.length > 0) {
			const fileName = this.files[0].name;
			$filename.text(fileName);
		} else {
			$filename.text('');
		}
	});

	
});



jQuery(document).ready(function ($) {
         
    // Handle dismissible alerts
    jQuery(document).on('click', '.uncannyowl-alert-close', function(e) { 
        e.preventDefault();
        $(this).closest('.uncannyowl-alert').fadeOut(300, function() {
            $(this).remove();
        });
    });
    
    // Also try direct click handler as backup
    jQuery('.uncannyowl-alert-close').on('click', function(e) {
        console.log('Direct click handler triggered');
        e.preventDefault();
        $(this).closest('.uncannyowl-alert').fadeOut(300, function() {
            $(this).remove();
        });
    });
});